import { utilityApi } from 'yxt-biz-pc/packages/api';

// import { Api } from 'yxt-biz-pc-base';
// const { utilityApi } = Api;
export const getTagSelectList = params => {
  return utilityApi.get('grouptags', params);
};

export const searchTag = data => {
  return utilityApi.post('tags/search4client?limit=10', data);
};

export const createTag = data => {
  return utilityApi.post('tags?usebody=true', data);
};

export const getEditType = (tagType) => {
  return utilityApi.get(`tagtypes/${tagType}`);
};
